import axiosInstance from 'src/lib/axios';

import { arquivosParaAnexos } from 'src/utils/ler-base64';

// ----------------------------------------------------------------------
// Cliente de anexos do portal — espelha o fluxo do fisco: converte cada File em
// base64 e faz POST JSON (não multipart); download vem como blob. Envia um a um
// e devolve quantos FALHARAM (0 = tudo certo), para a tela avisar parcialmente.
// ----------------------------------------------------------------------

async function enviarLista(url: string, arquivos: File[], extra: Record<string, unknown> = {}): Promise<number> {
  const anexos = await arquivosParaAnexos(arquivos);
  let falhas = 0;
  for (const a of anexos) {
    try {
      await axiosInstance.post(url, { ...extra, ...a });
    } catch {
      falhas += 1;
    }
  }
  return falhas;
}

export function anexarProtocolo(protocolo: string, arquivos: File[]): Promise<number> {
  return enviarLista('/portal-api/protocolo/documentos', arquivos, { protocolo });
}

export function anexarPlantao(id: number | string, arquivos: File[]): Promise<number> {
  return enviarLista(`/portal-api/plantao-fiscal/${id}/documentos`, arquivos);
}

async function baixarBlob(url: string, nome: string) {
  const res = await axiosInstance.get(url, { responseType: 'blob' });
  const href = URL.createObjectURL(res.data);
  const link = document.createElement('a');
  link.href = href;
  link.download = nome || 'arquivo';
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(href);
}

export function baixarProtocoloDoc(protocolo: string, pdId: number, nome: string) {
  return baixarBlob(
    `/portal-api/protocolo/documento/download?protocolo=${encodeURIComponent(protocolo)}&pd_id=${pdId}`,
    nome,
  );
}

export function baixarPlantaoDoc(id: number | string, docId: number, nome: string) {
  return baixarBlob(`/portal-api/plantao-fiscal/${id}/documentos/${docId}/download`, nome);
}
